import i18n from '../i18n';

/**
 * The title an invitation shows (C327). An activity with no name anywhere —
 * no custom title, no place data — is "an activity", as the stored notices
 * say it (C301), on every surface that lists it: Coming up, the planner
 * strip and its answer toasts, the bell's Invitations tab and the response
 * modal. Never an empty heading, and never "Invitation from Olive: " with
 * nothing after it.
 *
 * Standing alone (a heading, a list row) it is capitalised, "An activity";
 * inside a sentence ("Declined an activity") pass `inSentence`.
 *
 * A trip keeps its own name (or nothing): "an activity" would be untrue of it.
 *
 * @param {string|null|undefined} title - the name the server sent
 * @param {{ trip?: boolean, inSentence?: boolean }} [opts]
 * @returns {string}
 */
export function inviteTitle(title, { trip = false, inSentence = false } = {}) {
  const named = typeof title === 'string' ? title.trim() : '';
  if (named) return title;
  if (trip) return named;
  return i18n.t(inSentence
    ? 'common:invitationTitle.untitledActivityInSentence'
    : 'common:invitationTitle.untitledActivity');
}

export default inviteTitle;
